/* eslint-disable no-unused-vars */
import { useState } from "react";
import { MultiProductLoaderCardProps } from "../../Services/CommonServices/propTypes";
import AutoplayVideoPlayer from "../../CommonComponents/AutoplayVideoPlayer";
import { useLanguage } from "../../Services/ContextProvider/LanguageContextProvider";

function MultiProductLoaderCard(props) {
  const [hasError, setHasError] = useState(false);
  const { t } = useLanguage();

  const handleError = (error) => {
    console.warn('Video loading error:', error);
    setHasError(true);
  };

  const handleReady = () => {
    // Video ready handler
  };

  if (hasError) {
    return (
      <div className={`outfit-loader-video ${props.loaderIndex === 2 && 'last-loader-card'} d-flex align-items-center justify-content-center`}
        style={{ width: '100%', height: '100%', background: '#f0f0f0', borderRadius: '10px 10px 14px 14px' }}>
        <div className="text-muted">{t('Loading...')}</div>
      </div>
    );
  }

  return (
    <>
      {/* <div>HIZI</div> */}
      {/* <ReactPlayer 
         url={props.loaderImage} 
         playing={true} 
         loop 
         muted={true}
         width="100%" 
         height="100%" 
         className={`outfit-loader-video ${props.loaderIndex === 2 && 'last-loader-card'}`} 
         playsinline={true}
         controls={false}
         onError={handleError}
         onReady={handleReady}
         config={{
           file: {
             attributes: {
               playsInline: true,
               muted: true,
               'webkit-playsinline': true,
               'x-webkit-airplay': 'allow',
               controls: false,
               preload: 'metadata'
             },
           },
         }}
       /> */}
 
       <AutoplayVideoPlayer
        url={props.loaderImage}
        fallbackImage={props.loaderFallbackImage}
        className={`outfit-loader-video ${props.loaderIndex === 2 && 'last-loader-card'}`}
        // onError={handleError}
        // onReady={handleReady}
        onStatusChange={(status) => {
          console.log('MultiProductLoaderCard video status:', status);
          if (status === 'BLOCKED') {
            setHasError(false); // Don't treat blocked as error
          }
        }}
        containerStyle={{
          position: 'relative', // Override fixed positioning
          width: '100%',
          height: '100%'
        }}
      /> 
    </>
  );
}

MultiProductLoaderCard.propTypes = MultiProductLoaderCardProps;
export default MultiProductLoaderCard;